import appsToDevelop from './appsToDevelop'

const HML_URL = 'https://cpaas-assets-hlg.lan.zenvia360.com'

const DEPENDENCIES = [
  {
    name: 'authentication',
    url: appsToDevelop.authentication
      ? 'http://localhost:1234/index.js'
      : `${HML_URL}/auth/index.js`,
  },
  {
    name: 'components',
    url: appsToDevelop.components
      ? 'http://localhost:8082/js/app.js'
      : `${HML_URL}/components/js/app.js`,
  },
  {
    name: 'channel-messenger',
    url: appsToDevelop.channelMessenger
      ? 'http://localhost:8086/app.js'
      : `${HML_URL}/channel-messenger/app.js`,
  },
  {
    name: 'channel-sms',
    url: appsToDevelop.channelSms
      ? 'http://localhost:8085/app.js'
      : `${HML_URL}/channel-sms/app.js`,
  },
  {
    name: 'channel-voice',
    url: appsToDevelop.channelVoice
      ? 'http://localhost:8090/app.js'
      : `${HML_URL}/channel-voice/app.js`,
  },
  {
    name: 'channel-whatsapp',
    url: appsToDevelop.channelWhatsApp
      ? 'http://localhost:8089/app.js'
      : `${HML_URL}/channel-whatsapp/app.js`,
  },
  {
    name: 'channel-webchat',
    url: appsToDevelop.channelWebchat
      ? 'http://localhost:8087/app.js'
      : `${HML_URL}/channel-webchat/app.js`,
  },
  {
    name: 'channel-rcs',
    url: appsToDevelop.channelRcs
      ? 'http://localhost:8091/app.js'
      : `${HML_URL}/channel-rcs/app.js`,
  },
  {
    name: 'eventbus',
    url: appsToDevelop.eventbus
      ? 'http://localhost:8083/index.js'
      : `${HML_URL}/eventbus/index.js`,
  },
  {
    name: 'feature-toggle',
    url: appsToDevelop.featureToggle
      ? 'http://localhost:12345/index.js'
      : `${HML_URL}/feature-toggle/index.js`,
  },
  {
    name: 'notifications',
    url: appsToDevelop.notifications
      ? 'http://localhost:8081/app.js'
      : `${HML_URL}/notifications/app.js`,
  },
  {
    name: 'selfservice',
    url: appsToDevelop.selfservice
      ? 'http://localhost:4201/main.js'
      : `${HML_URL}/selfservice/main-es5.js`,
  },
  {
    name: 'home',
    url: appsToDevelop.home
      ? 'http://localhost:8088/app.js'
      : `${HML_URL}/cpaas-home/app.js`,
  },
  {
    name: 'customer-area',
    url: appsToDevelop.customerPanel
      ? 'http://localhost:9090/app.js'
      : `${HML_URL}/customer-area/app.js`,
  },
  {
    name: 'flows',
    url: appsToDevelop.flows
      ? 'http://localhost:8084/main.js'
      : `${HML_URL}/flows/main-es5.js`,
  },
  {
    name: 'organizations',
    url: appsToDevelop.organizations
      ? 'http://localhost:8092/app.js'
      : `${HML_URL}/platform-organizations/app.js`,
  },
  {
    name: 'campaign-sidebar',
    url: appsToDevelop.campaignSidebar
      ? 'http://localhost:8093/app.js'
      : `${HML_URL}/campaign-sidebar/app.js`,
  },
  {
    name: 'contacts',
    url: appsToDevelop.campaignContacts
      ? 'http://localhost:8094/app.js'
      : `${HML_URL}/contacts/app.js`,
  },
  {
    name: 'campaign-automation',
    url: appsToDevelop.campaignAutomation
      ? 'http://localhost:8095/app.js'
      : `${HML_URL}/campaign-automation/app.js`,
  },
  {
    name: 'campaign-dispatches',
    url: appsToDevelop.campaignDispatches
      ? 'http://localhost:8101/app.js'
      : `${HML_URL}/campaign-dispatches/app.js`,
  },
  {
    name: 'builder',
    url: appsToDevelop.campaignBuilder
      ? 'http://localhost:8096/app.js'
      : `${HML_URL}/builder/app.js`,
  },
  {
    name: 'broadcast',
    url: appsToDevelop.platformBroadcast
      ? 'http://localhost:8102/app.js'
      : `${HML_URL}/platform-broadcast/app.js`,
  },
  {
    name: 'channel-instagram',
    url: appsToDevelop.channelInstagram
      ? 'http://localhost:8097/app.js'
      : `${HML_URL}/channel-instagram/app.js`,
  },
  {
    name: 'platform-report',
    url: appsToDevelop.platformReport
      ? 'http://localhost:8099/app.js'
      : `${HML_URL}/platform-report/app.js`,
  },
  {
    name: 'labs',
    url: appsToDevelop.labs
      ? 'http://localhost:8500/platform-labs.js'
      : `${HML_URL}/zlabs-showcase/platform-labs.js`,
  },
  {
    name: 'platform-errors-page',
    url: appsToDevelop.platformErrorsPage
      ? 'http://localhost:8100/app.js'
      : `${HML_URL}/platform-errors-page/app.js`,
  },
  {
    name: 'home-v2',
    url: appsToDevelop.homeV2
      ? 'http://localhost:8100/app.js'
      : `${HML_URL}/home-v2/app.js`,
  },
  {
    name: 'navbar-v2',
    url: appsToDevelop.navbarV2
      ? 'http://localhost:8101/app.js'
      : `${HML_URL}/navbar-v2/app.js`,
  },
  {
    name: 'feedback-service',
    url: appsToDevelop.feedbackService
      ? 'http://localhost:8110/index.js'
      : `${HML_URL}/feedback-service/index.js`,
  },
  {
    name: 'channel-v2',
    url: appsToDevelop.channelV2
      ? 'http://localhost:8111/app.js'
      : `${HML_URL}/channel-v2/app.js`,
  },
  {
    name: 'customer-data-service',
    url: appsToDevelop.customerDataService
      ? 'http://localhost:8112/index.js'
      : `${HML_URL}/customer-data-service/index.js`,
  },
]

export default {
  DEPENDENCIES,

  LOGS_URL: appsToDevelop.logsApi
    ? 'http://localhost:3000'
    : 'https://logs-api-hlg.zenvia.com',

  WEB_COMPONENTS_URL: appsToDevelop.webComponents
    ? 'http://localhost:8085/build/platform-web-components.esm.js'
    : `${HML_URL}/platform-web-components/platform-web-components.js`,

  WEB_CHAT: 'https://static.zenvia.com/embed/js/zenvia-chat.hlg.min.js',
}
